import { Button, Text } from "@fluentui/react-components";
import { useAtom, useAtomValue } from "jotai";
import { useTranslation } from "react-i18next";
import { selectedCategoryFilterAtom } from "store";
import { benefitContentTabAtom } from "store/UIBenefitsPage";

import { Flex } from "components/styled";
import { useAppTheme } from "hooks/useAppTheme";
import { useSetDefaultBenefitCurrency } from "hooks/useSetDefaultBenefitCurrency";

import { CategoryFilterItem } from "./CategoryFilterItem";
import { useFilterCategoryOptions } from "./useFilterCategoryOptions";

export function CategoryFilter() {
  useSetDefaultBenefitCurrency();

  const { t } = useTranslation();
  const theme = useAppTheme();

  const categoryOptions = useFilterCategoryOptions();
  const [categoryFilters, setSelectedCategoryFilters] = useAtom(selectedCategoryFilterAtom);
  const selectedContentTab = useAtomValue(benefitContentTabAtom);

  const allFiltersSelected = categoryFilters[selectedContentTab]?.length === categoryOptions.length;

  if (!categoryOptions.length) {
    return null;
  }

  return (
    <Flex direction="column" width={"100%"} data-help="benefits-category-filter">
      <Flex
        $justify="space-between"
        width={"100%"}
        style={{
          paddingBottom: "5px",
          borderBottom: `1px solid ${theme.palette.neutralLight}`,
        }}
      >
        <Text
          weight="semibold"
          style={{
            color: theme.palette.neutralSecondaryAlt,
          }}
          size={300}
        >
          {t("hbh.category.label")}
        </Text>

        <Button
          appearance="subtle"
          size="small"
          style={{
            color: theme.palette.neutralSecondaryAlt,
          }}
          onClick={() => {
            if (allFiltersSelected) {
              setSelectedCategoryFilters((prev) => {
                return {
                  ...prev,
                  [selectedContentTab]: [],
                };
              });
            } else {
              setSelectedCategoryFilters((prev) => {
                return {
                  ...prev,
                  [selectedContentTab]: categoryOptions.map((item) => {
                    return { id: item.id, name: item.name };
                  }),
                };
              });
            }
          }}
        >
          {allFiltersSelected ? t("hbh.clearAll.label") : t("hbh.selectAll.label")}
        </Button>
      </Flex>
      <Flex width={"100%"} direction="column" align="flex-start">
        {categoryOptions.map((item) => {
          return <CategoryFilterItem key={item.id} id={item.id} name={item.name} />;
        })}
      </Flex>
    </Flex>
  );
}
